var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPurpleColorLine = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 6,
  height: 3,
  viewBox: "0 0 6 3",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 0.727295,
  y1: 1.50635,
  x2: 6.72729,
  y2: 1.50635,
  stroke: "#8171CB",
  strokeWidth: 2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPurpleColorLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/purple-color-line.8a971bbfb05452b25d6f6b1ace4b3508.svg";